export const enum InputWidgetElementType {
    ShowCase = 'showCase',
    Input = 'input',
    InputCurrency = 'inputCurrency',
    InputPhone = 'inputPhone',
    Slider = 'slider',
    RadioBox = 'radioBox',
    ResultBox = 'resultBox',
    CheckBox = 'checkBox',
    OtpCode = 'OTPCode',
    OtpCodeV2 = 'OTPCodeV2',
    MasterDetail = 'masterDetail',
    AccountsAndCardsList = 'accountsAndCardsList',
    ClientSharingRequest = 'ClientSharingRequest',
    DropDown = 'dropDown',
    PriceBanner = 'priceBanner',
    InvoiceList = 'invoiceList',
    PinInput = 'inputPin',
    DateSelector = 'dateSelector',
    TimeSelector = 'timeSelector',
    TimeSlot = 'timeSlot',
    ListInput = 'listInput',
    ItemSelector = 'itemSelector',
    OperationList = 'operationList',
    CSI = 'csi_widget',
    PhoneBook = 'phoneBook',
    Chips = 'chips',
    ProgressBar = 'progressBar',
    TextArea = 'textArea',
    CashbackCategory = 'cashbackCategory',
    OperationListSelector = 'operationListSelector',
}
